import type { $Fetch } from 'nitropack';
import type { BFFResponse } from '~/types/BFFResponse';
import type { Flag } from '~/plugins/featureFlags';

export default ($fetch: $Fetch) => {
  const getFeatureFlags = async () => $fetch<BFFResponse<Flag[]>>('/featureFlags');

  const getFeatureFlagsByCountry = async (country: string) => $fetch<BFFResponse<string[]>>(`/featureFlags/${country}`);

  const updateFeatureFlags = async (body: any) => $fetch<BFFResponse<string[]>>('/featureFlags', { method: 'POST', body });

  return {
    getFeatureFlags,
    getFeatureFlagsByCountry,
    updateFeatureFlags,
  };
};
